import Axios from "axios";
import { API_URL } from "../config";
import { IFilter } from "~/hooks/useFilters";

export class FilterService {
  static getFilters = async () => await Axios.get(`${API_URL}/search_filters`);
  static addFilter = async (data: IFilter) => await Axios.post(`${API_URL}/search_filter`, data);
  static deleteFilter = async (id: number) => await Axios.delete(`${API_URL}/search_filter/${id}`);
}
